import React, { useState } from "react";
import { AudioLines } from "lucide-react";
import { TunerOverlay } from "./TunerOverlay";
import { HOME_THEME as T } from "../lib/homeTheme";
import { cn } from "../lib/utils";

export interface StudioTunerControlProps {
  /** Compacto para cabeceras de estudio. */
  compact?: boolean;
  className?: string;
}

/**
 * Botón + overlay del afinador para estudios sin AppBar global.
 */
export const StudioTunerControl: React.FC<StudioTunerControlProps> = ({
  compact = false,
  className,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={cn(
          "inline-flex items-center gap-1.5 rounded-lg border font-sans font-semibold transition-colors hover:bg-white/10",
          compact ? "h-8 px-2.5 text-[10px] tracking-[0.1em] uppercase" : "h-9 px-3 text-xs",
          className,
        )}
        style={{
          borderColor: "rgba(153,246,228,0.35)",
          color: T.mint,
          background: "rgba(153,246,228,0.08)",
        }}
        aria-label="Abrir afinador"
      >
        <AudioLines className={compact ? "w-3.5 h-3.5" : "w-4 h-4"} />
        Afinador
      </button>
      <TunerOverlay expanded={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default StudioTunerControl;
